// extracted by mini-css-extract-plugin
export var title = "cart-module--title--Z68P9";
export var table = "cart-module--table--rAqU3";
export var wrap = "cart-module--wrap--Aqn7N";
export var totals = "cart-module--totals--uOD2I";
export var summary = "cart-module--summary--FNRo3";
export var grandTotal = "cart-module--grandTotal--KehhY";
export var checkoutButton = "cart-module--checkoutButton--T0q0g";
export var labelColumn = "cart-module--labelColumn--7C3iw";
export var collapseColumn = "cart-module--collapseColumn--iNrRF";
export var productHeader = "cart-module--productHeader--aAjB+";
export var imageHeader = "cart-module--imageHeader--xEUH4";
export var emptyStateContainer = "cart-module--emptyStateContainer--HM5Yo";
export var emptyStateHeading = "cart-module--emptyStateHeading--u5LZO";
export var emptyStateLink = "cart-module--emptyStateLink--CBOMh";